export default __webpack_public_path__ + "static/media/pantry1-afterB-1024w.3150223b.webp";